import { render, staticRenderFns } from "./PostcodeAutocomplete.vue?vue&type=template&id=2887e609&"
import script from "./PostcodeAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PostcodeAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports